import { EventListener } from '@Events/EventListener';

import type { Logger } from '@Infrastructure/entities/logger';

export type VocSettings = {
  id: string;
  url: string;
  logger: Logger;
};

export class VocListener extends EventListener {
  constructor(settings: VocSettings) {
    super();

    this.init(settings);
    this.on('touchFilters', this.touchFilters.bind(this));
  }

  touchFilters() {
    if (window.UXS) {
      window.UXS.sendEvent('touchFilters');
    }
  }

  init(settings: VocSettings) {
    try {
      window._uxsSettings = { id: settings.id };
      const script = document.createElement('script');
      script.async = true;
      script.id = 'UXS-script';
      script.src = settings.url;
      document.body.appendChild(script);
    } catch (error) {
      settings.logger.log(`Error when load UX Feedback: ${error}`);
    }
  }
}
